import React, { useState, useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight, Camera, Expand } from "lucide-react";
import "./Gallery.css";

import gallery1 from "../../assets/new/Gallery1.jpeg";
import gallery2 from "../../assets/new/Gallery2.jpeg";
import gallery3 from "../../assets/new/Gallery3.jpeg";
import gallery4 from "../../assets/new/Gallery4.jpeg";
import gallery5 from "../../assets/new/Gallery5.jpeg";
import gallery6 from "../../assets/new/Gallery6.jpeg";
import gallery7 from "../../assets/new/Gallery7.jpeg";
import gallery8 from "../../assets/new/Gallery8.jpeg";
import gallery9 from "../../assets/new/Gallery9.jpeg";
import gallery10 from "../../assets/new/Gallery10.jpeg";
import gallery11 from "../../assets/new/Gallery11.jpeg";
import gallery12 from "../../assets/new/Gallery12.jpeg";
import gallery13 from "../../assets/new/Gallery13.jpeg";
import gallery14 from "../../assets/new/Gallery14.jpeg";
import gallery15 from "../../assets/new/Gallery15.jpeg";

const GALLERY_IMAGES = [
  { id: 1, src: gallery1, title: "Luxury Cab Fleet", tag: "Fleet" },
  { id: 2, src: gallery2, title: "Professional Drivers", tag: "Team" },
  { id: 3, src: gallery3, title: "Comfortable Rides", tag: "Fleet" },
  { id: 4, src: gallery4, title: "Airport Service", tag: "Service" },
  { id: 5, src: gallery5, title: "Clean Vehicles", tag: "Fleet" },
  { id: 6, src: gallery6, title: "Family Travel", tag: "Service" },
  { id: 7, src: gallery7, title: "Corporate Travel", tag: "Service" },
  { id: 8, src: gallery8, title: "Wedding Cars", tag: "Fleet" },
  { id: 9, src: gallery9, title: "City Tours", tag: "Service" },
  { id: 10, src: gallery10, title: "24/7 Service", tag: "Team" },
  { id: 11, src: gallery11, title: "24/7 Service", tag: "Team" },
  { id: 12, src: gallery12, title: "24/7 Service", tag: "Team" },
  { id: 13, src: gallery13, title: "24/7 Service", tag: "Team" },
  { id: 14, src: gallery14, title: "24/7 Service", tag: "Team" },
  { id: 15, src: gallery15, title: "24/7 Service", tag: "Team" },
];

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(GALLERY_IMAGES[index]);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = useCallback(() => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
  }, []);

  const prevImage = useCallback(() => {
    setCurrentIndex((prev) => {
      const newIndex = prev === 0 ? GALLERY_IMAGES.length - 1 : prev - 1;
      setSelectedImage(GALLERY_IMAGES[newIndex]);
      return newIndex;
    });
  }, []);

  const nextImage = useCallback(() => {
    setCurrentIndex((prev) => {
      const newIndex = prev === GALLERY_IMAGES.length - 1 ? 0 : prev + 1;
      setSelectedImage(GALLERY_IMAGES[newIndex]);
      return newIndex;
    });
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "ArrowRight") nextImage();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedImage, closeLightbox, prevImage, nextImage]);

  return (
    <>
      <section className="gallery" id="gallery">
        <div className="gallery-header">
          {/* <div className="gallery-badge">
            <Camera size={15} strokeWidth={2} />
            <span>Our Gallery</span>
          </div> */}
          <h2>
            A Glimpse Into <span>Excellence</span>
          </h2>
          <p>
            Explore our fleet, our team, and the everyday moments that go into
            delivering a reliable, comfortable ride.
          </p>
        </div>

        <div className="gallery-grid">
          {GALLERY_IMAGES.map((image, index) => (
            <button
              type="button"
              className="gallery-item"
              key={image.id}
              onClick={() => openLightbox(index)}
              aria-label={`View ${image.title}`}
            >
              <img src={image.src} alt={image.title} loading="lazy" />
              <span className="gallery-item-overlay">
                <span className="gallery-item-tag">{image.tag}</span>
                <span className="gallery-item-title">{image.title}</span>
                <span className="gallery-item-expand">
                  <Expand size={16} />
                </span>
              </span>
            </button>
          ))}
        </div>
      </section>

      {selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <button
            className="lightbox-close"
            onClick={closeLightbox}
            aria-label="Close"
          >
            <X size={24} />
          </button>

          <button
            className="lightbox-prev"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            aria-label="Previous image"
          >
            <ChevronLeft size={24} />
          </button>

          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.title} />
            <div className="lightbox-caption">
              <span className="lightbox-tag">{selectedImage.tag}</span>
              {/* <h3>{selectedImage.title}</h3> */}
              <span className="lightbox-count">
                {currentIndex + 1} / {GALLERY_IMAGES.length}
              </span>
            </div>
          </div>

          <button
            className="lightbox-next"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            aria-label="Next image"
          >
            <ChevronRight size={24} />
          </button>
        </div>
      )}
    </>
  );
}